import { render } from "./MetricTableChooser.vue?vue&type=template&id=bc997b80"
import script from "./MetricTableChooser.vue?vue&type=script&lang=js"
export * from "./MetricTableChooser.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__